<template>
  <div id="dc_mypage">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section>
            <h2>ユーザ管理</h2>
            <dd-account-manaeger />
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import {mapActions, mapState} from 'vuex'
// import store from '../../store/index'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import * as AppEc from '../utils/AppEc'
import {DC_URL} from '../../constants/App'
import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'
import DcAccountManager from '../components/user/DcAccountManager'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap,
    'dd-account-manaeger': DcAccountManager,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      pageKey: 'dcUserManager',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'mypage', key: 'dcMyPage', title: 'マイページ', route: 'DcMyPage'},
        {id: 'dcUserManager', key: 'dcUserManager', title: 'ユーザ管理', route: 'DcUserManager'}
      ]
    }
  },
  computed: {
    ...mapState({
      userList: state => state.userList
    })
  },
  methods: {
    ...mapActions({ getUserList: 'loadUserListDc' }),
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
    },
    onEdit: function (userObj) {
      let modalData = {
        userObj: userObj
      }
      AppEc.showUserModal(modalData)
    },
    onDel: function (userObj) {
      let modalData = {
        messages: ['本当に削除しますか？'],
        modalType: 'confirm',
        textAlign: 'center',
        onOk: () => {
          let payload = {
            userId: userObj.userId,
            userType: userObj.userType
          }
          axios.post(DC_URL.USER + '/delete-user', payload
          ).then(response => {
            this.$store.dispatch('loadUserListDc')
            let modalData = {
              messages: ['削除しました。'],
              textAlign: 'center'
            }
            App.showModal(modalData)
          }).catch(error => {
            Api.handleError(error, this.errorMessage, this.validateErrorMessages)
            this.$router.push('/error')
          })
        }
      }
      App.showModal(modalData)
    },
    /** 最終ログイン日時 */
    lastLogin: function (id) {
      if (this.userList && this.userList.length > 0) {
        // idで該当するユーザーを検索
        let userObj = this.userList.find(obj => { if (obj.userId === id) return obj })
        if (userObj.userLastlogindt === null) {
          return ''
        } else {
          return moment(userObj.userLastlogindt).format('YYYY/MM/DD HH:mm:ss')
        }
      }
    },
    onClickUserInvitation: function () {
      AppEc.showInviteUserModal()
    },
    isLoginUser: function (userId) {
      console.log('userId:' + userId + ' login:' + this.loginUserId)
      if (userId === this.loginUserId) {
        return true
      }
      return false
    },
    userType: function (val) {
      if (val === 'DC_ADMIN') {
        return '管理者'
      } else if (val === 'DC_USER') {
        return '使用者'
      }
      return ''
    }
  },
  mounted: function () {
  },
  created: function () {
  }
}
</script>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcUserManager.vue